import React from 'react'
import PropTypes from 'prop-types'
import { NarrowPageLayout } from '~/components/PageLayout'
import styled from '@emotion/styled'
import { device, H2, space } from '@ticketswap/solar'
import BrowseButtons from './BrowseButtons'
import dynamic from 'next/dynamic'
import { Skeleton } from '~/components/ListCard/Skeleton'
import ErrorBoundary from '~/components/ErrorBoundary'

const FollowedEvents = dynamic(() => import('./FollowedEvents'), {
  ssr: false,
  loading: () => <Skeleton />,
})

const DiscoverFeed = dynamic(() => import('~/components/DiscoverFeed'), {
  ssr: false,
  loading: () => <Skeleton count={2} />,
})

const FacebookEvents = dynamic(() => import('~/components/FacebookEvents'), {
  ssr: false,
  loading: () => <Skeleton />,
})

const StyledNarrowPageLayout = styled(NarrowPageLayout)`
  padding-top: ${space[16]};
  padding-bottom: ${space[48]};

  @media ${device.tablet} {
    padding-top: ${space[32]};
    padding-bottom: ${space[64]};
  }
`

const StyledH2 = styled(H2)`
  margin-top: ${space[44]};
  margin-bottom: ${space[8]};
`

const DiscoverLayout = styled.div`
  display: grid;
  grid-gap: ${space[16]};
  grid-template-columns: minmax(0, 1fr);

  @media ${device.tablet} {
    grid-gap: ${space[24]};
  }
`

const HomePageContent = ({ t }) => {
  return (
    <StyledNarrowPageLayout>
      <BrowseButtons t={t} />

      <StyledH2>{t('home:discover.title')}</StyledH2>
      <ErrorBoundary>
        <DiscoverLayout>
          <FollowedEvents t={t} />
          <DiscoverFeed t={t} />
          <FacebookEvents t={t} />
        </DiscoverLayout>
      </ErrorBoundary>
    </StyledNarrowPageLayout>
  )
}

HomePageContent.propTypes = {
  t: PropTypes.func.isRequired,
}

export default HomePageContent
